export const getTime = (timestamp) => {
  const minutes = timestamp?.getMinutes() < 10 ? "0" + timestamp?.getMinutes() : timestamp?.getMinutes();
  const hours = timestamp?.getHours() % 12 === 0 ? "12" : timestamp?.getHours() % 12;
  const time = timestamp.getHours() > 12 ? hours + ":" + minutes + "PM" : hours + ":" + minutes + "AM";
  return time;
};
